let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("63hQz")).then(() => parcelRequire('6NyjW'));